/*
  传入封面  cover:
  音乐src  url:

  未开始：notStarted
  播放状态：playing
  暂停状态：pause
  结束状态：ended
  loading状态：loading

*/

import * as React from 'react'
import * as Styles from './MusicPlayer.style'
import {classes} from 'typestyle'
import globalBus from '@/services/Bus'
import {mta} from '../../utils/tools'
import {useGlobalBus} from '@/services/global-bus'

export function MusicPlayer() {
    const audioPlayerRef = React.useRef<HTMLAudioElement>()
    const [cover, setCover] = React.useState<string>('')
    const [showPlayer, setShowPlayer] = React.useState<boolean>(false)
    const [playStatus, setPlayStatus] = React.useState<string>('notStarted')
    const [lectureUrl, setLectureUrl] = React.useState<string>('')
    const [showButton, setShowButton] = React.useState<boolean>(false)

    let delayTimer: NodeJS.Timeout
    //  status: notStarted  playing  pause  ended  loading  afterDistance

    useGlobalBus({
        audioPlayerStatusChange: (info) => {
           if (info.status === 'PAUSE') {
                setPlayStatus('pause')
                setShowButton(true)
                audioPlayerRef.current.pause()
           } else {
            if (!showPlayer) {
                  setShowPlayer(true)
                }
            setPlayStatus('playing')
            audioPlayerRef.current.play()
           }
        },
        playerInfo: (info) => {
            setPlayStatus('loading')
            setShowButton(false)
            clearInterval(delayTimer)
            if (info) {
                if (!showPlayer) {
                    setShowPlayer(true)
                }
                setLectureUrl(info.lecture_url)
                setCover(info.cover)
                window.sessionStorage.setItem('HOMEPAGE_AudioPlayId', info.playId)
                playAudio(info.url)
            }
        }
    })

    React.useEffect(() => {
        return () => {
            clearInterval(delayTimer)
        }
    }, [])

    const sendPlayInfo = (status: string) => {
        if (status === 'PAUSE') {
            globalBus.emit({
                 audioPlayerStatusChange: {
                     status: 'PAUSE',
                     operationID: window.sessionStorage.getItem('HOMEPAGE_AudioPlayId')
                }
            })
        } else {
            globalBus.emit({
                audioPlayerStatusChange: {
                    status: 'PLAY',
                    operationID: window.sessionStorage.getItem('HOMEPAGE_AudioPlayId')
               }
           })
        }
    }

    const setStatus = (status: string) => {
        switch (status) {
            case 'pause':
                setPlayStatus('pause')
                setShowButton(true)
                audioPlayerRef.current.pause()
                sendPlayInfo('PAUSE')
                return
            case 'play':
                setPlayStatus('playing')
                audioPlayerRef.current.play()
                sendPlayInfo('PLAY')
                getPlayTimer()
                globalPlayerListner()
                return
        }
    }

    const getPlayTimer = () => {
        delayTimer = setInterval(() => {
           if (audioPlayerRef.current.currentTime > 5) {
                setShowButton(true)
                clearInterval(delayTimer)
           }
        }, 200)
    }

    const globalPlayerListner = () => {
        audioPlayerRef.current.addEventListener('ended', () => {
            setStatus('pause')
        })
    }

    const playAudio = (url: string) => {
        if (audioPlayerRef.current && audioPlayerRef.current !== null) {
            audioPlayerRef.current.src = url
            audioPlayerRef.current.play()
            audioPlayerRef.current.addEventListener('canplaythrough', () => setStatus('play'))
            mta(`main-homepage-listen-playBtn-${window.sessionStorage.getItem('HOMEPAGE_AudioPlayId')}`)
        }
    }

    const gotoChannel = (lecture: string) => {
        mta(`main-homepage-listen-toChannel-${window.sessionStorage.getItem('HOMEPAGE_AudioPlayId')}`)
        if (audioPlayerRef.current && audioPlayerRef.current !== null) {
            const playTime = (audioPlayerRef.current.currentTime)
            location.assign(lecture + `&playTime=${playTime}`)
        }
    }

    const closeMusicPlayer = () => {
        setShowPlayer(false)
        mta(`main-homepage-listen-closeBtn-${window.sessionStorage.getItem('HOMEPAGE_AudioPlayId')}`)
    }

    return (
        <div className={classes(Styles.MusicPlayer, showPlayer ? '' : Styles.defaultHiddenStatus)}>
            <div className={Styles.MusicPlayerWrap}>
               <div className={Styles.emptyBlock}/>
                <div className={Styles.playerCore}>
                    {playStatus === 'pause' &&
                        <div className={Styles.closeBtn}>
                            <img src="https://static-cos.lycheer.net/picture/10490565_0d25be68bbb79d267c1f3c101287b5e0.jpg" alt="" onClick={() => closeMusicPlayer()}/>
                        </div>
                    }
                    { (showButton || playStatus === 'pause') &&
                        <div className={classes(Styles.checkLecture, Styles.showButtonMoveTrack)}>
                            <a onClick={() => gotoChannel(lectureUrl)} style={{display: 'block'}}>
                                 <button>查看课程</button>
                            </a>
                        </div>
                     }
                    <div className={Styles.playCoverWrap}>
                        <div className={Styles.playerCoreBg} style={{backgroundImage: `url(${cover})`}}/>
                        <span>
                            {/* loading */}
                            {playStatus === 'loading' &&
                                <img className={Styles.loadingStatus} src="https://static-cos.lycheer.net/picture/10490565_405a8c6831a5451d5494ba6656256e98.jpg" alt="loading"/>
                            }
                            {/* 暂停中 */}
                            {playStatus === 'pause' &&
                                <img src="https://static-cos.lycheer.net/picture/10490565_95d9832a6535a7f2e2ed94a75170e0d5.jpg" alt="pause" onClick={() => setStatus('play')}  />
                            }
                            {/* 播放中 */}
                            {playStatus === 'playing' &&
                                <img src="https://static-cos.lycheer.net/picture/10490565_b0e480e717284d2850c05cad07d265d8.jpg" alt="播放中" onClick={() => setStatus('pause')} />
                            }
                        </span>

                    </div>
                </div>

                <audio
                    ref={audioPlayerRef}
                    id="HOMEPAGE_AUDIOPLAYER"
                    preload="auto"
                    style={{height: 0, width: 0, visibility: 'hidden'}}
                />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/plugins/MusicPlayer/MusicPlayer.tsx